// Where to send a user right after they authenticate, so an action they started
// while logged out (e.g. registering for a cohort) resumes seamlessly.
//
// Sources, in order:
//   1. an explicit ?redirect= query param,
//   2. a durable localStorage destination that survives auth-provider and
//      multi-step setup redirects, and
//   3. the legacy sessionStorage cohort key.
// Only same-origin relative paths are honored, to prevent open redirects.
const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

function safeRelativePath(value) {
  const path = String(value || '').trim();
  return /^\/(?!\/)[^\\\r\n]*$/.test(path) ? path : null;
}

export function persistPostAuthRedirect(destination) {
  const safeDestination = safeRelativePath(destination);
  if (!safeDestination) return null;
  try { localStorage.setItem(POST_AUTH_REDIRECT_KEY, safeDestination); } catch (_) { /* ignore */ }
  return safeDestination;
}

export function clearPostAuthRedirect(destination) {
  try {
    const stored = safeRelativePath(localStorage.getItem(POST_AUTH_REDIRECT_KEY));
    if (!destination || stored === safeRelativePath(destination)) {
      localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
    }
  } catch (_) { /* ignore */ }
}

export function resolvePostAuthRedirect(search) {
  try {
    const param = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : '')).get('redirect');
    const destination = safeRelativePath(param);
    if (destination) return persistPostAuthRedirect(destination);
  } catch (_) { /* ignore */ }
  try {
    const stored = safeRelativePath(localStorage.getItem(POST_AUTH_REDIRECT_KEY));
    if (stored) return stored;
  } catch (_) { /* ignore */ }
  try {
    const pendingCohort = sessionStorage.getItem('pendingCohortEnroll');
    if (pendingCohort) return persistPostAuthRedirect(`/cohorts/${encodeURIComponent(pendingCohort)}`);
  } catch (_) { /* ignore */ }
  return null;
}
